import type { MoveHistoryEntry } from '../../../../deps/game/moveHistory/moveHistory.types'
import { JsonViewer } from '../../library/JsonViewer/JsonViewer'
import { MoveProgress } from '../MoveProgress/MoveProgress'
import { formatDistanceToNow } from 'date-fns'

interface MoveDetailsProps {
  entry: MoveHistoryEntry
  aiProgressMessages?: string[]
}

export function MoveDetails({ entry, aiProgressMessages = [] }: MoveDetailsProps) {
  const exactTime = new Date(entry.timestamp).toLocaleString()
  const humanTime = formatDistanceToNow(new Date(entry.timestamp), { addSuffix: true })

  return (
    <div className="px-2 pb-2 border-t border-divider pt-2 space-y-2">
      <div>
        <div className="text-xs font-semibold mb-1 text-muted">
          Time: <span title={exactTime}>{humanTime}</span>
        </div>
      </div>
      
      <JsonViewer title="Move JSON" data={entry.move} />
      
      {entry.response && (
        <JsonViewer title="Server Response" data={entry.response} />
      )}
      
      {entry.error && (
        <div className="text-danger text-xs">
          <strong>Error:</strong> {entry.error}
        </div>
      )}

      {entry.divergent && (
        <div className="text-danger text-xs">
          <strong>⚠ Possible state divergence:</strong> this client's locally
          computed state before this move didn't match the submitting
          client's claimed hash. Could indicate non-deterministic game rules
          — or a benign race from two clients submitting near-simultaneously.
        </div>
      )}

      {aiProgressMessages.length > 0 && (
        <MoveProgress messages={aiProgressMessages} />
      )}
    </div>
  )
}

